/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadServiceResourceRequest {
    getFixupPrototypeFunction() { return WorkloadServiceResourceRequest.fixupPrototype; }

    static newInstance(model: Partial<WorkloadServiceResourceRequest>): WorkloadServiceResourceRequest {
        let obj = Object.assign(new WorkloadServiceResourceRequest(), model);
        WorkloadServiceResourceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadServiceResourceRequest>): WorkloadServiceResourceRequest {
        if (!model) return null;
        return WorkloadServiceResourceRequest.newInstance(<WorkloadServiceResourceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadServiceResourceRequest) {
        if (!obj) return;

        models.WorkloadServiceResourceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadServiceResourceRequest): boolean {
        Object.setPrototypeOf(obj, WorkloadServiceResourceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which cloud account ids to fetch resources for
     */
    service_account_ids: Array<string>;

}
